export const USER_ID = 'userId';

// export const SKIP_START = true;
export const SKIP_START = false;

const LAYOUT_TYPES = [
	'full',
	'full-color',
	'question-left',
	'question-right',
];

export const MOBILE_BREAKPOINT = 600;

export const AGREE_OPTIONS = [
	{ label: 'Strongly Disagree', value: 'strongly_disagree' },
	{ label: 'Disagree', value: 'disagree' },
	{ label: 'Agree', value: 'agree' },
	{ label: 'Strongly Agree', value: 'strongly_agree' },
];

const agreeSort = [
	'strongly_disagree',
	'disagree',
	'agree',
	'strongly_agree'
]

export const QUESTIONS = [
	{
		id: 'cq_1',
		label: 'Question One',
		question: 'Do you think about the amount of water you use at home?',
		type: 'yes-no',
		layout: 'question-left',
		options: [
			{ label: 'Yes', value: 'yes' },
			{ label: 'No', value: 'no' },
			{ label: `Don't know`, value: 'unsure'}
		],
		sortOrder: ['yes', 'no', 'unsure'],
		image: 'cq_1-min.jpg'
	},
	{
		id: 'cq_2',
		label: 'Question Two',
		question: 'What is your first interaction with water when you wake up?',
		type: 'radios',
		layout: 'full-color',
		options: [
			{ label: "Drink water", value: "drink_water"},
			{ label: "Shower / Bath", value: "shower_bath"},
			{ label: "Make Coffee / Tea", value: "coffee_tea"},
			{ label: "Wash Face", value: "wash_face"},
			{ label: "Brush Teeth", value: "brush_teeth"},
			{ label: "Flush Toilet", value: "flush_toilet"},
			{ label: "Don't Know / Not Sure", value: "dont_know"}
		],
		image: 'cq_2-min.jpg'
	},
	{
		id: 'cq_3',
		label: 'Question Three',
		question: 'How many interactions with water do you think you have throughout the day?',
		type: 'input',
		layout: 'full',
		sortOrder: [ '<4', '5-7', '8-11', '12-15', '16+' ],
		option: 'I have {input} interactions with water throughout my day.',
	},
	{
		id: 'cq_4',
		label: 'Question Four',
		question: 'What time of day do you use the most water?',
		type: 'time-selector',
		layout: 'question-right',
		options: [
			{ label: 'Early Morning', value: 'early_morning' },
			{ label: 'Morning', value: 'morning' },
			{ label: 'Afternoon', value: 'afternoon' },
			{ label: 'Late Afternoon', value: 'late_afternoon' },
			{ label: 'Evening', value: 'evening' },
			{ label: 'Late Evening', value: 'late_evening' },
		],
		sortOrder: [ 'early_morning', 'morning', 'afternoon', 'late_afternoon', 'evening', 'late_evening' ],
		image: 'cq_4-min.jpg'
	},
	{
		id: 'cq_5',
		label: 'Question Five',
		question: 'What role does water play?',
		header: 'Water...',
		type: 'multi-agree',
		layout: 'question-left',
		options: [
			{
				"subQuestion": "brings me comfort",
				"id": "cq_5_1",
				sortOrder: agreeSort
			},
			{
				"subQuestion": "brings my family together",
				"id": "cq_5_2",
				sortOrder: agreeSort
			},
			{
				"subQuestion": "brings me close to loved ones",
				"id": "cq_5_3",
				sortOrder: agreeSort
			},
			{
				"subQuestion": "is an important part of my daily routine",
				"id": "cq_5_4",
				sortOrder: agreeSort
			},
			{
				"subQuestion": "is important to my overall health and well-being",
				"id": "cq_5_5",
				sortOrder: agreeSort
			},
			{
				"subQuestion": "can change my mood (e.g. uplift or calm me)",
				"id": "cq_5_6",
				sortOrder: agreeSort
			},
			{
				"subQuestion": "relaxes me",
				"id": "cq_5_7",
				sortOrder: agreeSort
			},
			{
				"subQuestion": "brings me a feeling of safety",
				"id": "cq_5_8",
				sortOrder: agreeSort
			},
			{
				"subQuestion": "brings me joy",
				"id": "cq_5_9",
				sortOrder: agreeSort
			},
			{
				"subQuestion": "is something I worry about",
				"id": "cq_5_10",
				sortOrder: agreeSort
			},
			{
				"subQuestion": "is something I take for granted",
				"id": "cq_5_11",
				sortOrder: agreeSort
			},
			{
				"subQuestion": "is something I am grateful for",
				"id": "cq_5_12",
				sortOrder: agreeSort
			}
		],
		image: 'cq_5-min.jpg'
	},
	{
		id: 'cq_6',
		label: 'Question Six',
		question: 'What is the single most important source of water in your home?',
		type: 'svg-chooser',
		layout: 'full',
		options: [
			{
				label: 'Kitchen faucet',
				value: 'kitchen_fauce'
			},
			{
				label: 'Bathroom faucet',
				value: 'bathroom_faucet'
			},
			{
				label: 'Shower',
				value: 'shower'
			},
			{
				label: 'Bath',
				value: 'bath'
			},
			{
				label: 'Refrigerator water dispenser',
				value: 'refrigerator_water_dispenser'
			},
			{
				label: 'Dishwasher',
				value: 'dishwasher'
			},
			{
				label: 'Washing Machine',
				value: 'washing_machine'
			},
			{
				label: 'Garden hose',
				value: 'garden_hose'
			},
		]
	},
	{
		id: 'cq_7',
		label: 'Question Seven',
		question: 'Do you agree or disagree?',
		type: 'multi-agree',
		layout: 'question-left',
		options: [
			{
				"question": "I would like to find ways to reduce my water usage at home",
				"id": "cq_7_1",
				sortOrder: agreeSort
			},
			{
				"question": "I feel safe drinking water from the faucet at home",
				"id": "cq_7_2",
				sortOrder: agreeSort
			},
			{
				"question": "I feel guilty about how much water I use",
				"id": "cq_7_3",
				sortOrder: agreeSort
			},
			{
				"question": "Friends or family have judged me for how much water I use",
				"id": "cq_7_4",
				sortOrder: agreeSort
			},
			{
				"question": "I feel pretty knowledgeable about water issues and conservation",
				"id": "cq_7_5",
				sortOrder: agreeSort
			},
			{
				"question": "As I get older, I feel more responsible for the water I use",
				"id": "cq_7_6",
				sortOrder: agreeSort
			},
			{
				"question": "I feel responsible for the amount of water I use outside my home",
				"id": "cq_7_7",
				sortOrder: agreeSort
			},
			{
				"question": "I am tuned into the environmental issues facing our world  ",
				"id": "cq_7_8",
				sortOrder: agreeSort
			},
			{
				"question": "I understand where my water comes from ",
				"id": "cq_7_9",
				sortOrder: agreeSort
			},
			{
				"question": "I know how much my water usage costs ",
				"id": "cq_7_10",
				sortOrder: agreeSort
			},
			{
				"question": "I trust the government to responsibly manage society’s water use/consumption",
				"id": "cq_7_11",
				sortOrder: agreeSort
			},
			{
				"question": "I wish I had more control over my water usage in the home",
				"id": "cq_7_12",
				sortOrder: agreeSort
			}
		],
		image: 'cq_7-min.jpg'
	},
	{
		id: 'video-screen',
		type: 'screen'
	}
];


// WEBPACK FOOTER //
// ./constants/index.js